import * as Yup from "yup";

const formValidation = Yup.object({
  additionMaxLevels: Yup.number().required("Please enter max addition level"),
  subtractionMaxLevels: Yup.string().required("Please enter max subtraction level"),
});

export { formValidation };